module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/glyphicons-halflings-regular.woff
// module id = jNsc
// module chunks = 1